/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerContentListItems.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Content List Items
 *  
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *  
 *  Created:    Monday, July 4, 2022 - 3:30 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      07/04/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    UPDATE_CONTENTLISTID
} from '../constants/actionTypeContentListItems';

const defaultState = {
    CONTENTLISTID: 0
};

const reducerContentListItems = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_CONTENTLISTID:
            return {
                ...state,
                CONTENTLISTID: parseInt(action.payload) ? parseInt(action.payload) : 0,
            }
        default:
            return state;
    }
};

export default reducerContentListItems;
